import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록] 관리대상 등록 화면에서 obj를 추가시 ip중복을 체크한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  checkIpaddressValidation(params) {
    return axios.post(`${baseUrl}/settings/device-registration-common/check-ipaddress-validation.do`, params);
  },
  /**
   * obj들을 삭제한다.
   * @author Ju
   * @param  {[type]} objIds [description]
   * @return {[type]}        [description]
   */
  deleteObjList(objIds) {
    return axios.post(`${baseUrl}/settings/device-registration-common/delete-obj-list.do`, objIds);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-common.js